const BADGE_IDS_KEY = 'credentialingEarnedBadgeIds';
export const BADGE_SUMMARIES_KEY = 'credentialingEarnedBadgeSummaries';
export const BADGE_MEDIA_KEY = 'credentialingBadgeMediaCache';
export const BADGE_STORAGE_EVENT = 'credentialing-badges-updated';

const safeParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    const parsed = JSON.parse(value);
    return parsed ?? fallback;
  } catch (error) {
    console.warn('[credentialingStorage] Failed to parse stored value', error);
    return fallback;
  }
};

export const getStoredBadgeSummaries = () => {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(BADGE_SUMMARIES_KEY);
  const parsed = safeParse(raw, []);
  return Array.isArray(parsed) ? parsed : [];
};

export const setStoredBadgeSummaries = (summaries) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(BADGE_SUMMARIES_KEY, JSON.stringify(summaries));
    window.dispatchEvent(new CustomEvent(BADGE_STORAGE_EVENT, { detail: { type: 'summaries' } }));
  } catch (error) {
    console.warn('[credentialingStorage] Failed to persist badge summaries', error);
  }
};

export const getStoredBadgeMedia = () => {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(BADGE_MEDIA_KEY);
  const parsed = safeParse(raw, {});
  return parsed && typeof parsed === 'object' ? parsed : {};
};

export const upsertBadgeMedia = (badgeId, media) => {
  if (!badgeId || typeof window === 'undefined') return;
  try {
    const cache = getStoredBadgeMedia();
    cache[badgeId] = {
      ...(cache[badgeId] || {}),
      ...media,
      updatedAt: Date.now(),
    };
    window.localStorage.setItem(BADGE_MEDIA_KEY, JSON.stringify(cache));
    window.dispatchEvent(new CustomEvent(BADGE_STORAGE_EVENT, { detail: { type: 'media', badgeId } }));
  } catch (error) {
    console.warn('[credentialingStorage] Failed to persist badge media', error);
  }
};

export const resetStoredBadgeData = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(BADGE_SUMMARIES_KEY);
  window.localStorage.removeItem(BADGE_MEDIA_KEY);
  window.dispatchEvent(new CustomEvent(BADGE_STORAGE_EVENT, { detail: { type: 'reset' } }));
};

export const getStoredEarnedBadgeIds = () => {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(BADGE_IDS_KEY);
  const parsed = safeParse(raw, []);
  return Array.isArray(parsed) ? parsed : [];
};
